// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PanelFooter":"bel_a bic_b bic_va bic_rv bic_rw bic_vu","PanelFooter--link":"bel_b"};